var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Checkbox/Thrinacia/Form-Field/Thrinacia/Tabs/Thrinacia/Form-Field/Thirnacia/Avatar"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 42",
    cx: 12,
    cy: 11.3233,
    r: 10.8468,
    fill: "#1FA9FF",
    stroke: "#1FA9FF",
    strokeWidth: 0.80649
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9767 16.9483C11.9845 16.9483 11.9923 16.9483 12 16.9483C12.0078 16.9483 12.0156 16.9483 12.0233 16.9483C13.5315 16.9447 14.876 16.5949 15.7553 16.0497C16.3641 15.8303 16.803 15.2551 16.8209 14.575C16.8213 14.5625 16.8214 14.5501 16.8214 14.5376C16.8214 14.5367 16.8214 14.5358 16.8214 14.5349C16.8214 14.5339 16.8214 14.5328 16.8214 14.5318V14.1358V13.7399L16.8214 13.7365L16.8214 13.734C16.8214 11.9588 14.6628 10.5197 12 10.5197C9.33722 10.5197 7.17859 11.9588 7.17859 13.734L7.17859 13.7379L7.17859 13.7399V14.1358V14.5318C7.17859 14.5328 7.17859 14.5339 7.17859 14.5349C7.17859 14.5358 7.17859 14.5367 7.17859 14.5376C7.17859 14.5501 7.17878 14.5625 7.17916 14.575C7.19704 15.2551 7.63591 15.8303 8.24474 16.0497C9.12401 16.5949 10.4685 16.9447 11.9767 16.9483Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 43",
    d: "M12.0001 10.923C13.5542 10.923 14.814 9.66314 14.814 8.10903C14.814 6.55493 13.5542 5.29507 12.0001 5.29507C10.446 5.29507 9.18611 6.55493 9.18611 8.10903C9.18611 9.66314 10.446 10.923 12.0001 10.923Z",
    fill: "white",
    stroke: "#1FA9FF",
    strokeWidth: 0.80649
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserNew);
export default __webpack_public_path__ + "static/media/userNew.ee34e4deb53912a5437e55d66225a434.svg";
export { ForwardRef as ReactComponent };